module.exports = __webpack_public_path__ + "img/banner_m.b1101575.png";